// Bodies of water a one-time customer declares when signing. Monthly
// signings derive the same inventory from their weekly product lines
// (api/_lib/onboarding-source.js deriveStandardWaters); a one-time quote has
// no recurring lines, so the customer answers this instead. Each answer maps
// to the monthly path's water types, keys and names so a later COS import
// sees one shape regardless of how the inventory was learned.

export const WATER_SETUP_OPTIONS = [
  { value: 'pool', label: 'Pool only',
    waters: [['pool-1', 'Pool', 'Pool']] },
  { value: 'pool_attached_spa', label: 'Pool + attached spa',
    waters: [['pool-1', 'Pool and attached spa', 'Pool + Attached spa']] },
  { value: 'pool_separate_spa', label: 'Pool + separate in-ground spa',
    waters: [['pool-1', 'Pool', 'Pool'], ['spa-1', 'Separate spa', 'Spa (in-ground)']] },
  { value: 'pool_above_ground_spa', label: 'Pool + separate above-ground spa or hot tub',
    waters: [['pool-1', 'Pool', 'Pool'], ['spa-1', 'Separate spa', 'Spa (above-ground)']] },
  { value: 'spa_in_ground', label: 'In-ground spa only',
    waters: [['spa-1', 'Spa', 'Spa (in-ground)']] },
  { value: 'spa_above_ground', label: 'Above-ground spa or hot tub only',
    waters: [['spa-1', 'Spa', 'Spa (above-ground)']] },
  { value: 'above_ground_pool', label: 'Above-ground pool',
    waters: [['pool-1', 'Above-ground pool', 'Pool (above-ground)']] },
  { value: 'other', label: 'Something else',
    waters: [['other-1', 'Other', 'Other']] },
];

export const waterSetupOption = (value) => WATER_SETUP_OPTIONS.find((o) => o.value === value) || null;
